<template>
  <div>
    <v-file-input
      v-model="internalFile"
      :label="modelValue && isUrl(modelValue) ? extractFileName(modelValue) : label"
      :disabled="loading"
      :rules="rules"
      accept="*"
      density="compact"
      clearable
      :prepend-inner-icon="modelValue && isUrl(modelValue) ? 'mdi-download' : undefined"
      @click:prepend-inner="onDownloadClick"
      @change="uploadFile"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { useFileUploadStore } from '@/store/fileUpload';

const props = defineProps<{
  modelValue: string | null;
  label?: string;
  rules?: any[];
  readonly?: boolean;
  icon?: string;
  module?: string;
  multiple?: boolean;
}>();

const emit = defineEmits(['update:modelValue']);
const fileUploadStore = useFileUploadStore();

const internalFile = ref<File | null>(null);
const loading = ref(false);

const uploadFile = async () => {
  if (!internalFile.value || !props.module) return;

  loading.value = true;
  try {
    const url = await fileUploadStore.uploadFile(props.module, internalFile.value);
    emit('update:modelValue', url);
  } catch (e) {
    console.error('[FileUploader] Error al subir archivo:', e);
  } finally {
    loading.value = false;
  }
};

// Limpieza automática
watch(() => props.modelValue, val => {
  if (!val) internalFile.value = null;
});

const isUrl = (val: any): boolean => {
  return typeof val === 'string' && /^https?:\/\//.test(val);
};

const extractFileName = (url: string): string => {
  try {
    const parts = url.split('?')[0].split('/');
    return decodeURIComponent(parts[parts.length - 1]);
  } catch (e) {
    return 'archivo';
  }
};

const onDownloadClick = () => {
  if (props.modelValue && isUrl(props.modelValue)) {
    window.open(props.modelValue as string, '_blank');
  }
};
</script>
